<template>
  <div class="setReminder">
    <el-card>
      <el-button type="primary" slot="header" size="medium"  @click="add()">{{$t('lang.lab_addRecord')}}</el-button>
      <el-button type="primary" slot="header" size="medium"  @click="returnList()">{{$t('lang.lab_returnList')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="setRemindercheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="chargePrice" :label="$t('lang.lab_recordPriceMoney')"></el-table-column>
        <el-table-column prop="chargeCount" :label="$t('lang.lab_countPrice')">
          <template slot-scope="scope">
            <span>{{ $t('lang.lab_di') + scope.row.chargeCount + $t('lang.lab_bi')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="chargeDate" :label="$t('lang.lab_createLabelTime')">
          <template slot-scope="scope">
            {{ scope.row.chargeDate | timeYMD }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" width="300px">
          <template slot-scope="scope">
          <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
          <el-button class="orange" @click="delete1(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, jumper"
          :page-count="pageCount"
          />
    </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="changeTitle"
      @closed="handleDialogClosed"
    >
      <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon" :rules="rules" class="form_show">
        <el-form-item :label="$t('lang.lab_countPrice')">
          <el-select class="input" v-model="form.chargeCount">
            <el-option
              v-for="(item,index) in priceSelect"
              :key="index.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_recordTime')">
          <div class="block">
            <el-date-picker v-model="form.cDate" type="date" value-format="timestamp" :placeholder="$t('lang.lab_please_Select') + $t('lang.lab_recordTime')" class="input"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_recordPriceMoney')" prop="chargePrice">
          <el-input v-model="form.chargePrice" @input="keyBA" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_recordPriceMoney')" maxlength="7"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rest('form')" class="cancel">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="addLabel('form')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:contractManageList
 *@Description:合同记账
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-30
 */
export default {
  data() {
    return {
      id: '', // 传过来的id
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      saveData: '', // 编辑时监听表单内容是否变化
      pageSize: 10, // 每页显示数量
      isDisabled: false, // 控制按钮可否点击
      multipleSelection: [], // 多选框
      tableData: [], // 列表数组
      count: 0, // 记账的下拉框选项个数
      show: false, // 弹框默认隐藏为false
      priceSelect: [], // 记账笔数下拉列表
      changeTitle: '', // 弹框的标题
      form: {
        chargePrice: '', // 交易金额
        chargeCount: '', // 分期笔数
        cDate: '' // 记账时间
      },
      rules: {
        chargePrice: [
          { required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_recordPriceMoney'), trigger: 'blur' }
        ]
      },
      setRemindercheckbox: require('@/config/enum').setRemindercheckbox, // 是否隐藏复选框
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    }
    if (this.$route.query.count) {
      this.count = parseInt(this.$route.query.count)
      for (var i = 0; i < this.count; i++) {
        this.priceSelect.push({
          id: i + 1,
          label: this.$i18n.t('lang.lab_di') + (i + 1) + this.$i18n.t('lang.lab_bi'),
          value: i + 1
        })
      }
    }
    this.getList()
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
       let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取记账列表
    getList() {
      let loading = this.$loading()
      this.$get(`/contractCharges?ContractId=${this.id}&pageSize=${this.pageSize}&pageNo=${this.pageNo}`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.tableData = res.list
          this.pageCount = res.pageCount
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 用户名只能输入数字
    keyBA() {
      // 仅保留数字和"."
      this.form.chargePrice = this.form.chargePrice.replace(/[^\d.]/g, '')
      // 两个连续的"."仅保留第一个"."
      this.form.chargePrice = this.form.chargePrice.replace(/\.{2,}/g, '.')
      // 去除其他"."
      this.form.chargePrice = this.form.chargePrice.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
      // 首位是0的话去掉
      if (this.form.chargePrice.indexOf('.') < 0 && this.form.chargePrice != '') {
        this.form.chargePrice = parseFloat(this.form.chargePrice)
      }
    },
    // 点击编辑展示弹框并赋值
    edit(row) {
      this.changeTitle = this.$i18n.t('lang.lab_editRecord')
      this.editId = row.id
      this.form.chargePrice = row.chargePrice
      this.form.chargeCount = Number(row.chargeCount)
      this.form.cDate = row.chargeDate
      this.saveData = JSON.stringify(this.form)
      this.show = true
    },
    // 点击添加记账展示弹框
    add() {
      this.editId = ''
      this.changeTitle = this.$i18n.t('lang.lab_addRecord')
      this.form.chargePrice = ''
      this.form.chargeCount = 1
      this.form.cDate = ''
      this.show = true
    },
    // 添加记账保存
    addLabel(form) {
      if (this.editId === '') {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let params = {
              ContractId: this.id,
              ChargePrice: this.form.chargePrice,
              ChargeCount: this.form.chargeCount,
              CDate: this.form.cDate
            }
            let loading = this.$loading()
            this.$post(`/contractCharges`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.show = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      } else {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let params = {
              ChargePrice: this.form.chargePrice,
              ChargeCount: this.form.chargeCount,
              CDate: this.form.cDate
            }
            let loading = this.$loading()
            this.$patch(`/contractCharges/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.show = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      }
    },
    // 清空表单
    rest(form) {
      this.$refs[ form ].resetFields()
      this.form.chargePrice = ''
      this.form.cDate = ''
      this.form.chargeCount = 1
    },
    // 返回合同管理
    returnList() {
      this.$router.push({ name: 'contractManageList' })
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.$refs.form.clearValidate()
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    commit() {
      this.pageNo = 1
      this.getList()
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getList()
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getList()
    },
    // 根据id删除标签
    delete1(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.$delete(`/contractCharges/` + id).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_del_success')
              })
              this.commit()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    },
  }
}
</script>

<style lang="scss">

</style>